import React from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { Collapse } from 'antd';
import { useUpdateComponentState } from '../../../hooks';
import icon1 from '@/assets/cybersecurity2026/topic900/section1-header-Alert.png';
import icon2 from '@/assets/cybersecurity2026/topic900/section1-header-Edit.png';
import icon3 from '@/assets/cybersecurity2026/topic900/section1-header-Eye-off.png';
import icon4 from '@/assets/cybersecurity2026/topic900/section1-header-Hard-drive.png';

import bubble_bg from '@/assets/cybersecurity2026/topic900/section1-img4.png';
// section1-img4
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import ArrowImg from '../../../../../../assets/cybersecurity2026/finger.gif';

const { Panel } = Collapse;

interface ISection3Props {
  settings: any;
}

const iconList = [icon1, icon2, icon3, icon4];

const Section1: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const updateComponentState = useUpdateComponentState();

  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const [checked, setChecked] = React.useState<any>([]);
  const [activeArr, setActiveArr] = React.useState([0, 1, 2, 3, 4, 5]);
  const [active, setActive] = React.useState<any>(0);

  const getArrayMin = (arr: any, value: any) => {
    const newArr = arr.filter((item: any) => item !== value);
    setActiveArr([...newArr]);
    if (!Array.isArray(newArr) || newArr.length === 0) {
      return null;
    }
    return Math.min(...newArr);
  };

  const changeTab = (key: any) => {
    if (!checked.includes(key)) {
      const newChecked = [...checked, key].filter(Boolean);
      setChecked(newChecked);
      if (newChecked.length >= 5) {
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'cybersecurity2026-topic900-section1-1'
        );
      }
      const min = getArrayMin(activeArr, Number(key));
      setActive(min);
    }
  };

  // const [state, setState] = useState({
  //   deepfakeFlagLeft: false,
  //   deepfakeFlagRight: false,
  // });

  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: '-50px',
  });

  // React.useEffect(() => {
  //   if (state.deepfakeFlagRight && state.deepfakeFlagLeft) {
  //     updateComponentState(
  //       p_course,
  //       p_topic,
  //       ID,
  //       'cybersecurity2026-topic900-section1-2'
  //     );
  //   }
  // }, [p_course, p_topic, state.deepfakeFlagLeft, state.deepfakeFlagRight]);

  return (
    <div className="topic-section-1 topic-section-1-en">
      <div className="title-container">
        <CTitle title={paragraphsSettings.header} />
      </div>
      <div className="dialogue-content" ref={targetRef}>
        {isVisible && (
          <div className="dialogue-text">
            <div
              className="dialogue-left text-focus-in"
              dangerouslySetInnerHTML={{ __html: paragraphsSettings.l1 }}
            >
              {/* // {paragraphsSettings.l1} */}
            </div>
            <div className="dialogue-right text-focus-in">
              {paragraphsSettings.l2}
            </div>
          </div>
        )}
        <img className="dialogue-bg" src={bubble_bg} alt="" />
      </div>
      <div className="visit" id="cybersecurity2026-topic900-section1-1">
        <Collapse
          expandIcon={({ isActive }) =>
            isActive ? (
              <MinusOutlined
                style={{ color: '#FFFFFF', fontSize: '1.75rem' }}
              />
            ) : (
              <PlusOutlined style={{ color: '#FFFFFF', fontSize: '1.75rem' }} />
            )
          }
          accordion
          onChange={(key) => changeTab(key)}
        >
          {paragraphsSettings?.panelData?.map((item: any, index: number) => (
            <Panel
              header={
                <>
                  {active === index && (
                    <img className="arrow-img" src={ArrowImg} alt="" />
                  )}
                  {item.header}
                  <img src={iconList[index]} alt="" />
                </>
              }
              key={index}
            >
              <div className="topic-section-1-img-con">
                {item.data.map((em: any) => (
                  <div className="content-container" key={em.content1}>
                    <div>
                      <span className="title-style">
                        {paragraphsSettings?.detail}
                      </span>
                      <span className="content-style"> {em.content1}</span>
                    </div>
                    <div>
                      <span className="title-style">
                        {paragraphsSettings?.result}
                      </span>
                      <span className="content-style">{em.content2}</span>
                    </div>
                    <div className="source">
                      {paragraphsSettings?.source}
                      <a
                        href={em.url || item.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item.sourceUrl || em?.sourceUrl}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </Panel>
          ))}
        </Collapse>
        <div className="triangle-container">
          <span className="triangle" /> {paragraphsSettings?.tips}
        </div>
      </div>
      {/* <div className="case-study" id="cybersecurity2026-topic900-section1-2">
        <div
          className="case-study-left"
          onClick={() => setState({ ...state, deepfakeFlagLeft: true })}
        >
          {!state.deepfakeFlagLeft ? (
            <img src={ArrowImg} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.caseStudy1}
            </span>
          )}
        </div>
        <div
          className="case-study-right"
          onClick={() => setState({ ...state, deepfakeFlagRight: true })}
        >
          {!state.deepfakeFlagRight ? (
            <img src={ArrowImg} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.caseStudy2}
            </span>
          )}
        </div>
      </div> */}
    </div>
  );
};

export default Section1;
